import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'transfer-status',
  templateUrl: './transfer-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe, NgClass],
})
export class TransferStatusComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output();
  dataProperty: string = '';
  constructor() {}
  ngOnInit(): void {}

  renderClass(state: string) {
    switch (state) {
      case 'Initiated':
        return 'bg-green-500';
      case 'TransferFromApproved':
        return 'bg-green-500';
      case 'TransferFromDeclined':
        return 'bg-green-500';
      case 'Scheduled':
        return 'bg-green-500';
      case 'Completed':
        return 'bg-green-500';
      case 'Void':
        return 'bg-green-500';
      case 'FailedOther':
        return 'bg-green-500';
      case 'Expired':
        return 'bg-green-500';
      case 'Decline':
        return 'bg-orage-500';
      default:
        return 'bg-red';
    }
  }
  splitCapitalCase(s: string) {
    return s.replace(/([A-Z])/g, ' $1').trim();
  }
}
